import React from "react";

import { acceptCookies, hasAcceptedCookies } from "../../config/cookies";
import "./styles.css";

const privacyPolicyUrl = process.env.REACT_APP_PRIVACY_POLICY_URL;

const setBodyPaddingBottom = (value: string) => {
  if (value) document.body.style.paddingBottom = value;
  else document.body.style.removeProperty("padding-bottom");
};

const CookieConsent = () => {
  const [isVisible, setIsVisible] = React.useState(() => !hasAcceptedCookies());
  const bannerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!isVisible) return;

    const previousPadding = document.body.style.paddingBottom;

    const applyOffset = () => {
      const height = bannerRef.current?.offsetHeight ?? 0;
      setBodyPaddingBottom(`${height}px`);
    };

    applyOffset();

    let observer: ResizeObserver | undefined;

    if (typeof ResizeObserver !== "undefined" && bannerRef.current) {
      observer = new ResizeObserver(applyOffset);
      observer.observe(bannerRef.current);
    }

    window.addEventListener("resize", applyOffset);

    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", applyOffset);
      setBodyPaddingBottom(previousPadding);
    };
  }, [isVisible]);

  if (!isVisible) return null;

  const handleAccept = () => {
    acceptCookies();
    setIsVisible(false);
  };

  return (
    <div
      ref={bannerRef}
      className="cookie-consent"
      role="region"
      aria-label="Aviso de cookies"
    >
      <div className="cookie-consent__content">
        <p className="cookie-consent__text">
          <strong className="cookie-consent__title">Nós usamos cookies</strong>
          Utilizamos cookies para manter sua sessão ativa, lembrar suas
          preferências e melhorar sua experiência no Conectado. Ao continuar
          navegando, você concorda com o uso desses cookies.
          {privacyPolicyUrl ? (
            <>
              {" "}
              <a
                className="cookie-consent__link"
                href={privacyPolicyUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Política de Privacidade
              </a>
              .
            </>
          ) : null}
        </p>

        <button
          type="button"
          className="cookie-consent__button"
          onClick={handleAccept}
        >
          Aceitar cookies
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
